import type { Notification, NotificationPreference, PreferencesMap } from '@/types/notifications';

// ============================================================
// MOCK DATA — Centro de Notificaciones (Bloque 41)
// Datos realistas para desarrollo. Se reemplazan con Supabase en producción.
// ============================================================

export const mockNotifications: Notification[] = [
  {
    id: 'notif-001',
    profile_id: 'mock-profile-1',
    type: 'PROGRAM_STARTING',
    title: 'Programa por comenzar: El Sabor del Mediodía',
    message: 'En 15 minutos comienza "El Sabor del Mediodía" en La Mexicana FM. Conéctate y participa en vivo con Alejandro Ramírez.',
    is_read: false,
    priority: 'normal',
    related_entity_type: 'program',
    related_entity_id: 'program-sabor-mediodia',
    action_url: '/radio/la-mexicana-fm',
    metadata: { radio_name: 'La Mexicana FM', program_name: 'El Sabor del Mediodía', announcer_name: 'Alejandro Ramírez' },
    created_at: '2026-07-15T11:45:00Z',
  },
  {
    id: 'notif-002',
    profile_id: 'mock-profile-1',
    type: 'RADIO_LIVE',
    title: 'Radio Nueva Actitud está en vivo',
    message: 'Radio Nueva Actitud acaba de iniciar transmisión en vivo. ¡No te lo pierdas!',
    is_read: false,
    priority: 'high',
    related_entity_type: 'radio',
    related_entity_id: 'radio-nueva-actitud',
    action_url: '/radio/radio-nueva-actitud',
    metadata: { radio_name: 'Radio Nueva Actitud', stream_url: null },
    created_at: '2026-07-15T10:30:00Z',
  },
  {
    id: 'notif-003',
    profile_id: 'mock-profile-1',
    type: 'ANNOUNCER_ON_AIR',
    title: 'Locutor al aire: Carlos Vega en Rock Total',
    message: 'Carlos Vega está al aire en Rock Total Radio con el programa "Rock Total en Vivo". Invitado sorpresa esta noche.',
    is_read: false,
    priority: 'normal',
    related_entity_type: 'announcer',
    related_entity_id: 'announcer-carlos-vega',
    action_url: '/radio/rock-total-radio',
    metadata: { radio_name: 'Rock Total Radio', announcer_name: 'Carlos Vega', program_name: 'Rock Total en Vivo' },
    created_at: '2026-07-14T19:50:00Z',
  },
  {
    id: 'notif-004',
    profile_id: 'mock-profile-1',
    type: 'REQUEST_ACCEPTED',
    title: 'Solicitud aceptada: Saludo al aire',
    message: 'Tu saludo fue aceptado. La Mexicana FM lo leerá próximamente al aire. ¡Gracias por participar, Marco!',
    is_read: true,
    priority: 'high',
    related_entity_type: 'radio',
    related_entity_id: 'radio-la-mexicana-fm',
    action_url: '/listener',
    metadata: { radio_name: 'La Mexicana FM', request_type: 'greeting' },
    created_at: '2026-07-14T12:15:00Z',
  },
  {
    id: 'notif-005',
    profile_id: 'mock-profile-1',
    type: 'REQUEST_PLAYED',
    title: 'Canción reproducida: "Vivir Mi Vida"',
    message: 'La canción que solicitaste "Vivir Mi Vida" de Marc Anthony fue reproducida en Radio Nueva Actitud.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'radio',
    related_entity_id: 'radio-nueva-actitud',
    action_url: '/radio/radio-nueva-actitud',
    metadata: { radio_name: 'Radio Nueva Actitud', song_title: 'Vivir Mi Vida', artist: 'Marc Anthony', played_at: '2026-07-13T16:45:00Z' },
    created_at: '2026-07-13T16:45:00Z',
  },
  {
    id: 'notif-006',
    profile_id: 'mock-profile-1',
    type: 'REQUEST_REJECTED',
    title: 'Solicitud rechazada: Canción no disponible',
    message: 'La canción "Despacito" no está disponible en la biblioteca actual de Banda Radio MX. Intenta con otra canción.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'radio',
    related_entity_id: 'radio-banda-radio-mx',
    action_url: null,
    metadata: { radio_name: 'Banda Radio MX', song_title: 'Despacito', reason: 'not_in_library' },
    created_at: '2026-07-13T14:00:00Z',
  },
  {
    id: 'notif-007',
    profile_id: 'mock-profile-1',
    type: 'NEW_PODCAST',
    title: 'Nuevo podcast: Entrevista exclusiva',
    message: 'Rock Total Radio publicó un nuevo episodio de podcast: "Entrevista exclusiva con la banda invitada de anoche".',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'podcast',
    related_entity_id: 'podcast-entrevista-rock',
    action_url: '/radio/rock-total-radio',
    metadata: { radio_name: 'Rock Total Radio', podcast_title: 'Entrevista exclusiva con la banda invitada' },
    created_at: '2026-07-12T18:00:00Z',
  },
  {
    id: 'notif-008',
    profile_id: 'mock-profile-1',
    type: 'CONTEST_STARTED',
    title: 'Concurso iniciado: Trivia Musical',
    message: 'Deportes Total Radio lanzó una trivia musical. Participa y gana entradas para la final de campeones.',
    is_read: true,
    priority: 'high',
    related_entity_type: 'contest',
    related_entity_id: 'contest-trivia-musical',
    action_url: '/radio/deportes-total-radio',
    metadata: { radio_name: 'Deportes Total Radio', contest_name: 'Trivia Musical', prize: 'Entradas final de campeones' },
    created_at: '2026-07-12T14:00:00Z',
  },
  {
    id: 'notif-009',
    profile_id: 'mock-profile-1',
    type: 'CONTEST_ENDING',
    title: 'Concurso por terminar: Canto 2026',
    message: 'El concurso de canto de La Kalle 99.9 cierra este domingo. Envía tu audio antes del sábado.',
    is_read: true,
    priority: 'high',
    related_entity_type: 'contest',
    related_entity_id: 'contest-canto-2026',
    action_url: '/radio/la-kalle-99-9',
    metadata: { radio_name: 'La Kalle 99.9', contest_name: 'Concurso de Canto 2026', deadline: '2026-07-19T23:59:00Z' },
    created_at: '2026-07-11T16:00:00Z',
  },
  {
    id: 'notif-010',
    profile_id: 'mock-profile-1',
    type: 'CONTEST_WINNER',
    title: 'Ganador de concurso: ¡Felicidades!',
    message: '¡Ganaste el concurso de Trivia Deportiva de Deportes Total Radio! Revisa tu correo para reclamar tu premio.',
    is_read: true,
    priority: 'urgent',
    related_entity_type: 'contest',
    related_entity_id: 'contest-trivia-deportiva',
    action_url: '/listener',
    metadata: { radio_name: 'Deportes Total Radio', contest_name: 'Trivia Deportiva', prize: 'Camiseta oficial autografiada' },
    created_at: '2026-07-10T09:00:00Z',
  },
  {
    id: 'notif-011',
    profile_id: 'mock-profile-1',
    type: 'RADIO_ANNOUNCEMENT',
    title: 'Aviso de Radio Fe y Esperanza',
    message: 'Radio Fe y Esperanza te invita a la Noche de Oración este viernes a las 7 PM. Entrada libre.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'radio',
    related_entity_id: 'radio-fe-y-esperanza',
    action_url: '/radio/radio-fe-y-esperanza',
    metadata: { radio_name: 'Radio Fe y Esperanza', event_name: 'Noche de Oración', event_date: '2026-07-18T19:00:00Z' },
    created_at: '2026-07-09T09:00:00Z',
  },
  {
    id: 'notif-012',
    profile_id: 'mock-profile-1',
    type: 'SYSTEM_NOTICE',
    title: 'Aviso del sistema: Mantenimiento programado',
    message: 'RadioFrecuenciaWeb realizará mantenimiento el domingo 20 de julio de 2:00 AM a 4:00 AM. Algunas funciones podrían no estar disponibles.',
    is_read: true,
    priority: 'normal',
    related_entity_type: null,
    related_entity_id: null,
    action_url: null,
    metadata: { maintenance_start: '2026-07-20T02:00:00Z', maintenance_end: '2026-07-20T04:00:00Z' },
    created_at: '2026-07-08T08:00:00Z',
  },
  {
    id: 'notif-013',
    profile_id: 'mock-profile-1',
    type: 'REQUEST_ATTENDED',
    title: 'Solicitud atendida: Canción en cola',
    message: 'Tu solicitud de canción fue recibida y está en la cola de reproducción de Radio Vida Nueva.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'radio',
    related_entity_id: 'radio-vida-nueva',
    action_url: '/radio/radio-vida-nueva',
    metadata: { radio_name: 'Radio Vida Nueva', song_title: 'Alabaré', queue_position: 3 },
    created_at: '2026-07-08T11:30:00Z',
  },
  {
    id: 'notif-014',
    profile_id: 'mock-profile-1',
    type: 'RADIO_LIVE',
    title: 'Banda Radio MX está en vivo',
    message: 'Acaban de arrancar "Tardes de Banda" con los mejores éxitos regionales mexicanos.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'radio',
    related_entity_id: 'radio-banda-radio-mx',
    action_url: '/radio/banda-radio-mx',
    metadata: { radio_name: 'Banda Radio MX', program_name: 'Tardes de Banda' },
    created_at: '2026-07-07T15:00:00Z',
  },
  {
    id: 'notif-015',
    profile_id: 'mock-profile-1',
    type: 'PROGRAM_STARTING',
    title: 'Programa por comenzar: La Mesa Redonda',
    message: 'En 15 minutos comienza "La Mesa Redonda" en Deportes Total Radio. Análisis completo de la jornada.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'program',
    related_entity_id: 'program-mesa-redonda',
    action_url: '/radio/deportes-total-radio',
    metadata: { radio_name: 'Deportes Total Radio', program_name: 'La Mesa Redonda' },
    created_at: '2026-07-06T11:45:00Z',
  },
  {
    id: 'notif-016',
    profile_id: 'mock-profile-1',
    type: 'NEW_PODCAST',
    title: 'Nuevo podcast: Cobertura especial',
    message: 'Radio Vida Nueva subió el podcast de la cobertura del evento benéfico del fin de semana.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'podcast',
    related_entity_id: 'podcast-cobertura-benefica',
    action_url: '/radio/radio-vida-nueva',
    metadata: { radio_name: 'Radio Vida Nueva', podcast_title: 'Cobertura especial: Evento benéfico' },
    created_at: '2026-07-05T11:00:00Z',
  },
  {
    id: 'notif-017',
    profile_id: 'mock-profile-1',
    type: 'SYSTEM_NOTICE',
    title: 'Aviso del sistema: Nuevas funciones',
    message: 'RadioFrecuenciaWeb lanzó nuevas funciones: notificaciones mejoradas, modo oscuro, y más. Actualizá la app para disfrutarlas.',
    is_read: true,
    priority: 'normal',
    related_entity_type: null,
    related_entity_id: null,
    action_url: null,
    metadata: { feature_list: ['notificaciones_mejoradas', 'modo_oscuro', 'widgets'] },
    created_at: '2026-07-03T10:00:00Z',
  },
  {
    id: 'notif-018',
    profile_id: 'mock-profile-1',
    type: 'CONTEST_STARTED',
    title: 'Concurso iniciado: Mejor foto veraniega',
    message: 'Radio Nueva Actitud lanzó concurso de fotos veraniegas. Subí tu mejor foto y ganá premios.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'contest',
    related_entity_id: 'contest-fotos-veraniegas',
    action_url: '/radio/radio-nueva-actitud',
    metadata: { radio_name: 'Radio Nueva Actitud', contest_name: 'Mejor foto veraniega', prize: 'Kit de playa + parlante Bluetooth' },
    created_at: '2026-07-02T08:00:00Z',
  },
  {
    id: 'notif-019',
    profile_id: 'mock-profile-1',
    type: 'REQUEST_ACCEPTED',
    title: 'Solicitud aceptada: Dedicación',
    message: 'Tu dedicación para María fue aceptada en Radio Fe y Esperanza. Será leída durante el programa de la tarde.',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'radio',
    related_entity_id: 'radio-fe-y-esperanza',
    action_url: '/radio/radio-fe-y-esperanza',
    metadata: { radio_name: 'Radio Fe y Esperanza', request_type: 'dedication', recipient: 'María' },
    created_at: '2026-07-01T15:30:00Z',
  },
  {
    id: 'notif-020',
    profile_id: 'mock-profile-1',
    type: 'ANNOUNCER_ON_AIR',
    title: 'Locutor al aire: Daniel Ortega en Radio Fe',
    message: 'El Pastor Daniel Ortega está al aire en Radio Fe y Esperanza con el programa "Reflexión Matutina".',
    is_read: true,
    priority: 'normal',
    related_entity_type: 'announcer',
    related_entity_id: 'announcer-daniel-ortega',
    action_url: '/radio/radio-fe-y-esperanza',
    metadata: { radio_name: 'Radio Fe y Esperanza', announcer_name: 'Daniel Ortega', program_name: 'Reflexión Matutina' },
    created_at: '2026-06-30T08:00:00Z',
  },
];

// ============================================================
// MOCK PREFERENCES
// ============================================================

export const mockNotificationPreferences: NotificationPreference[] = [
  { id: 'pref-001', profile_id: 'mock-profile-1', preference_type: 'global', reference_id: null, enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-002', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-la-mexicana-fm', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-003', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-nueva-actitud', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-004', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-rock-total', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-005', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-deportes-total', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-006', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-fe-y-esperanza', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-007', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-banda-mx', enabled: false, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-07-10T00:00:00Z' },
  { id: 'pref-008', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-vida-nueva', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-009', profile_id: 'mock-profile-1', preference_type: 'radio', reference_id: 'radio-kalle-99', enabled: false, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-07-12T00:00:00Z' },
  { id: 'pref-010', profile_id: 'mock-profile-1', preference_type: 'program', reference_id: 'program-sabor-mediodia', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-011', profile_id: 'mock-profile-1', preference_type: 'program', reference_id: 'program-rock-total-vivo', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-012', profile_id: 'mock-profile-1', preference_type: 'program', reference_id: 'program-mesa-redonda', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-07-05T00:00:00Z' },
  { id: 'pref-013', profile_id: 'mock-profile-1', preference_type: 'announcer', reference_id: 'announcer-carlos-vega', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-014', profile_id: 'mock-profile-1', preference_type: 'announcer', reference_id: 'announcer-alejandro-ramirez', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-015', profile_id: 'mock-profile-1', preference_type: 'announcer', reference_id: 'announcer-daniel-ortega', enabled: false, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-07-01T00:00:00Z' },
  { id: 'pref-016', profile_id: 'mock-profile-1', preference_type: 'podcast', reference_id: 'podcast-entrevista-rock', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-017', profile_id: 'mock-profile-1', preference_type: 'podcast', reference_id: 'podcast-cobertura-benefica', enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-018', profile_id: 'mock-profile-1', preference_type: 'contest', reference_id: null, enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-019', profile_id: 'mock-profile-1', preference_type: 'request', reference_id: null, enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
  { id: 'pref-020', profile_id: 'mock-profile-1', preference_type: 'admin_notice', reference_id: null, enabled: true, created_at: '2026-06-01T00:00:00Z', updated_at: '2026-06-01T00:00:00Z' },
];

export const mockPreferencesGrouped: PreferencesMap = {
  global: mockNotificationPreferences.filter((p) => p.preference_type === 'global'),
  radio: mockNotificationPreferences.filter((p) => p.preference_type === 'radio'),
  program: mockNotificationPreferences.filter((p) => p.preference_type === 'program'),
  announcer: mockNotificationPreferences.filter((p) => p.preference_type === 'announcer'),
  podcast: mockNotificationPreferences.filter((p) => p.preference_type === 'podcast'),
  contest: mockNotificationPreferences.filter((p) => p.preference_type === 'contest'),
  request: mockNotificationPreferences.filter((p) => p.preference_type === 'request'),
  admin_notice: mockNotificationPreferences.filter((p) => p.preference_type === 'admin_notice'),
};